module.exports = __webpack_public_path__ + "static/media/calendar-unavailability.b2bcaf88.png";